import { Link, useLocation } from 'react-router-dom'
import {
  LogOut,
  LayoutDashboard,
  FileText,
  Square,
  Menu,
  Globe,
  Settings,
  Newspaper,
  Tag,
  Image,
  Users,
  ClipboardList,
} from 'lucide-react'
import { useAuthStore } from '../stores/authStore'

const menuConfig = {
  'dashboard': { name: 'Dashboard', href: '/dashboard', icon: LayoutDashboard },
  'pages': { name: 'Pages', href: '/pages', icon: FileText },
  'posts': { name: 'Posts', href: '/posts', icon: Newspaper },
  'categories': { name: 'Categories', href: '/categories', icon: Tag },
  'media': { name: 'Media', href: '/media', icon: Image },
  'forms': { name: 'Forms', href: '/forms', icon: ClipboardList },
  'block-types': { name: 'Blocks', href: '/block-types', icon: Square },
  'navigations': { name: 'Navigations', href: '/navigations', icon: Menu },
  'languages': { name: 'Languages', href: '/languages', icon: Globe },
  'users': { name: 'Users', href: '/users', icon: Users },
  'settings': { name: 'Settings', href: '/settings', icon: Settings },
}

export default function Sidebar({ children }) {
  const { user, logout, canManageUsers } = useAuthStore()

  const getNavigation = () => {
    const menuPermissions = user?.menu_permissions || []
    const baseMenus = [
      'dashboard',
      'pages',
      'posts',
      'categories',
      'media',
      'forms',
      'block-types',
      'navigations',
      'languages',
    ]

    const navigation = baseMenus
      .filter((key) => !menuPermissions.length || menuPermissions.includes(key))
      .map((key) => menuConfig[key])

    if (!menuPermissions.length || menuPermissions.includes('users')) {
      if (canManageUsers()) {
        navigation.push(menuConfig['users'])
      }
    }

    navigation.push(menuConfig['settings'])

    return navigation
  }

  const navigation = getNavigation()

  return (
    <div className="flex flex-col flex-grow bg-white border-r border-gray-200">
      <div className="flex h-16 items-center px-4">
        <h1 className="text-xl font-bold text-gray-900">Ginger CMS</h1>
      </div>

      {children || <Navigation items={navigation} />}

      <div className="border-t border-gray-200 p-4">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <div className="h-8 w-8 rounded-full bg-primary-500 flex items-center justify-center">
              <span className="text-sm font-medium text-white">
                {user?.name?.charAt(0)?.toUpperCase()}
              </span>
            </div>
          </div>
          <div className="ml-3 flex-1">
            <p className="text-sm font-medium text-gray-700">{user?.name}</p>
            <p className="text-xs text-gray-500">{user?.email}</p>
            {user?.roles && (
              <p className="text-xs text-primary-600">
                {user.roles[0]?.name?.charAt(0).toUpperCase() +
                  user.roles[0]?.name?.slice(1)}
              </p>
            )}
          </div>
        </div>
        <button
          onClick={logout}
          className="mt-3 flex w-full items-center px-2 py-2 text-sm text-gray-600 hover:bg-gray-50 hover:text-gray-900 rounded-md"
        >
          <LogOut className="mr-3 h-4 w-4" />
          Sign out
        </button>
      </div>
    </div>
  )
}

export function Navigation({ items }) {
  const location = useLocation()

  return (
    <nav className="flex-1 space-y-1 px-2 py-4">
      {items.map((item) => {
        const isActive = location.pathname === item.href
        return (
          <Link
            key={item.name}
            to={item.href}
            className={`group flex items-center px-2 py-2 text-sm font-medium rounded-md ${
              isActive
                ? 'bg-primary-100 text-primary-900'
                : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
            }`}
          >
            <item.icon className="mr-3 h-5 w-5" />
            {item.name}
          </Link>
        )
      })}
    </nav>
  )
}
